import useFetchData from '../hooks/useFetchData';
import Loader from './Loader';
import { FetchDataFunction, FetchDataOptions } from '../hooks/useFetchData';

interface WithDataWrapperProps<T> {
  fetchData: FetchDataFunction<T>;
  errorMessage: string;
  options?: FetchDataOptions;
  initialState: T;
  children: (data: T) => React.ReactElement;
}

export default function WithDataWrapper<T>({fetchData, errorMessage, options, initialState, children}: WithDataWrapperProps<T>) {
  const { isPending, error, data } = useFetchData({
    fetchData: fetchData,
    errorMessage: errorMessage,
    options: options,
    initialState: initialState
  });

  if (isPending) return <Loader />;
  if (error) return <p className="center-text">{errorMessage.replace('Error occured while fetching', 'Missing')}</p>;

  return children(data);
};